import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import ReactSpreadsheet from "react-spreadsheet";
var StyledComponent = function (props) {
    var columnLabels = props.columnLabels, otherProps = __rest(props, ["columnLabels"]);
    return (_jsx(ReactSpreadsheet, __assign({ columnLabels: columnLabels }, otherProps)));
};
export default StyledComponent;
